import { Platform } from 'react-native';

/** Saves a text file: a download on the web; on phones the share sheet (save to Files, send…). */
export async function saveTextFile(content: string, fileName: string, mime: string) {
  if (Platform.OS === 'web') {
    const url = URL.createObjectURL(new Blob([content], { type: `${mime};charset=utf-8` }));
    const link = document.createElement('a');
    link.href = url; link.download = fileName; link.style.display = 'none';
    document.body.appendChild(link); link.click(); document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return;
  }
  const { Share } = await import('react-native');
  try {
    const FileSystem = await import('expo-file-system/legacy');
    const uri = `${FileSystem.cacheDirectory}${fileName}`;
    await FileSystem.writeAsStringAsync(uri, content, { encoding: FileSystem.EncodingType.UTF8 });
    // Android's share sheet takes text, not file URLs.
    await Share.share(Platform.OS === 'ios' ? { url: uri, title: fileName } : { message: content, title: fileName });
  } catch {
    await Share.share({ message: content, title: fileName });
  }
}

/**
 * Saves a printable HTML document as PDF: on the web the browser's print dialog for just this
 * document ("Save as PDF"); on iPhone a PDF file through the share sheet; on Android the system
 * print dialog (which also saves as PDF).
 */
export async function savePdf(html: string, fileName: string) {
  if (Platform.OS === 'web') {
    const frame = document.createElement('iframe');
    frame.setAttribute('aria-hidden', 'true');
    Object.assign(frame.style, { position: 'fixed', right: '0', bottom: '0', width: '0', height: '0', border: '0' });
    document.body.appendChild(frame);
    const doc = frame.contentWindow!.document;
    doc.open(); doc.write(html); doc.close();
    // The file name the browser suggests comes from the document title.
    doc.title = fileName.replace(/\.pdf$/i, '');
    await new Promise(resolve => setTimeout(resolve, 300));
    frame.contentWindow!.focus();
    frame.contentWindow!.print();
    setTimeout(() => frame.remove(), 60_000);
    return;
  }
  const Print = await import('expo-print');
  if (Platform.OS === 'android') { await Print.printAsync({ html }); return; }
  const { uri } = await Print.printToFileAsync({ html });
  const { Share } = await import('react-native');
  await Share.share({ url: uri, title: fileName });
}
